import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
import VentList from './VentList';
import { analytics } from '../utils/analytics';

const FeedSection = ({ vents, filteredVents, feedFilter, setFeedFilter, sessionId, onUpdate }) => {
  if (vents.length === 0) return null;

  const getFilterClass = (key) => {
    if (feedFilter !== key) return 'text-zinc-600 hover:text-zinc-400';
    if (key === 'suggestions') return 'bg-vent-secondary/20 text-vent-secondary';
    return 'bg-vent-primary/20 text-vent-primary';
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.5 }}
      className="mt-8 sm:mt-12"
    >
      <div className="flex items-center justify-between mb-4 sm:mb-6">
        <h3 className="font-heading text-lg sm:text-xl font-bold text-zinc-300 flex items-center gap-2">
          <MessageCircle className="w-5 h-5 text-vent-primary" />
          Feed
        </h3>
        <div className="flex bg-black/40 rounded-lg p-0.5 gap-0.5" data-testid="feed-filter">
          {[
            { key: 'all', label: 'All' },
            { key: 'vents', label: 'Vents' },
            { key: 'suggestions', label: 'Thoughts' }
          ].map(({ key, label }) => (
            <button
              key={key}
              onClick={() => { setFeedFilter(key); analytics.filterChange(key); }}
              className={`px-3 py-1.5 rounded-md text-xs font-heading font-bold tracking-wider transition-all ${getFilterClass(key)}`}
              data-testid={`filter-${key}`}
            >
              {label}
            </button>
          ))}
        </div>
      </div>

      {filteredVents.length > 0 ? (
        <VentList vents={filteredVents} sessionId={sessionId} onUpdate={onUpdate} />
      ) : (
        <p className="text-center text-zinc-600 text-sm py-8">
          {feedFilter === 'suggestions' ? 'No topic suggestions yet' : 'No vents yet'}
        </p>
      )}
    </motion.div>
  );
};

export default FeedSection;
